"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Fraserland Organics
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 2.1.10-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 * no description
 */
class DefaultApi extends runtime.BaseAPI {
    /**
     * Get a randomly selected dashboard image from ../../assets/dashboard
     */
    async dashboardImageGetRaw() {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/dashboard_image`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Get a randomly selected dashboard image from ../../assets/dashboard
     */
    async dashboardImageGet() {
        await this.dashboardImageGetRaw();
    }
    /**
     * Get all the values in a specified dropdown. (No authentication required)
     */
    async dropdownListPostRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/dropdown_list`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.DropdownListBodyToJSON(requestParameters.dropdownListBody),
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get all the values in a specified dropdown. (No authentication required)
     */
    async dropdownListPost(requestParameters) {
        const response = await this.dropdownListPostRaw(requestParameters);
        return await response.value();
    }
    /**
     * Get all the assets in the map
     */
    async mapListGetRaw() {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/map_list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.AssetFromJSON));
    }
    /**
     * Get all the assets in the map
     */
    async mapListGet() {
        const response = await this.mapListGetRaw();
        return await response.value();
    }
}
exports.DefaultApi = DefaultApi;
